import { useState, useEffect } from "react";
import { getFolderList, SaveFolderName, UpdateFolderName, DeleteFolderName } from './../../utils/APIClient'
import { useForm } from "react-hook-form";
import { triggerAlert, ConfirmationAlert } from './../../utils/commonFunctions'
import Modal from 'react-bootstrap/Modal';
import { createThemeData, customStyles, MinLengthValidation, MaxLengthValidation } from './../../utils/Constants'
import DataTable, { createTheme } from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { getOnlyToken } from '../../utils/commonFunctions';

const Folders = () => {
    document.title = "Callingo | Folders"
    const { register, handleSubmit, formState: { errors }, watch, reset, setValue, getValues } = useForm();
    const [folderList, setfolderList] = useState([])
    const [hide, sethide] = useState(false)
    const [editid, seteditid] = useState()
    const [disabled, setdisabled] = useState(false)
    const [loading, setLoading] = useState(false);
    const [totalPages, settotalPages] = useState()
    const [page_size, setpage_size] = useState(10)
    const [page_number, setpage_number] = useState(1)
    const [searchTerm, setSearchTerm] = useState("")
    const [searchTimeout, setSearchTimeout] = useState(null)
    const navigate = useNavigate();

    createTheme('solarized', createThemeData, 'dark');
    const columns = [
        {
            name: "Sr.No",
            selector: (row, i) => i,
            cell: (row, i) => i + 1,
        },
        {
            name: "Company Name",
            selector: (row) => row.folder_data.company_name,
            cell: row => row.folder_data.company_name,
        },

        {
            name: "Action",
            cell: row => (
                <div className="col-auto" id="tooltip-container9">
                    <button className="btn btn-link text-warning btn-lg p-0 me-1" onClick={() => { sethide(true); onloadeddata(row);reset() }}  >
                        <i className="ri-edit-box-line  "></i>
                    </button>
                    <button
                        className="btn btn-link text-danger btn-lg p-0"
                        onClick={() => { checkFolderUsageAndDelete(row); }}
                        title="Delete Folder"
                    >
                        <i className="ri-delete-bin-line"></i>
                    </button>
                </div>
            ),
        },

    ]
    const handlePageChange = page => {
        getFolderLists(page_size, page, searchTerm)
        setpage_number(page);
    };

    const handlePerRowsChange = async (newPerPage, page = page_number) => {
        getFolderLists(newPerPage, page, searchTerm)
        setpage_size(newPerPage);
    };

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        if (searchTimeout) {
            clearTimeout(searchTimeout);
        }
        const timeout = setTimeout(() => {
            getFolderLists(page_size, 1, value);
            setpage_number(1);
        }, 300);

        setSearchTimeout(timeout);
    };
    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: 'All',
    };
    const getFolderLists = async (pageSize = page_size, pageNumber = page_number, search = "") => {
        setLoading(true);
        try {
            let folders = await getFolderList(pageSize, pageNumber, search);
            if (folders.data) {
                setLoading(false);
                if (folders.data.status_code == 200) {
                    setfolderList([...folders.data.folders])
                    settotalPages(folders.data.pagination.total_items);
                }
            }
        } catch (error) {
            setLoading(false);
            triggerAlert('error', '', error.response.data.message || 'Something went wrong');
            console.error(error);
        }
    }
    const submitFolder = async (data) => {
        setdisabled(true)
        if (editid) {
            data.folder_id = editid

            try {
                const response = await UpdateFolderName(data);
                const respdata = response.data;
                if (respdata.status_code == 200) {
                    setdisabled(false)
                    triggerAlert('success', '', `Folder updated successfully` || 'Something went wrong');
                    getFolderLists(page_size, page_number, searchTerm);
                    sethide(false)
                }
            } catch (error) {
                setdisabled(false)
                triggerAlert('error', '', error.response.data.message || 'Something went wrong');
                console.error(error);

            }
        } else {
            try {
                const response = await SaveFolderName(data);
                const respdata = response.data;
                if (respdata.status_code == 200) {
                    setdisabled(false)
                    triggerAlert('success', '', `Folder created successfully` || 'Something went wrong');
                    getFolderLists(page_size, page_number, searchTerm);
                    sethide(false)
                }
            } catch (error) {
                setdisabled(false)
                triggerAlert('error', '', error.response.data.message || 'Something went wrong');
                console.error(error);
            }
        }

    }
    const onloadeddata = (data) => {

        setTimeout(() => {
            setValue("folder_name", data.folder_data.folder_name)
            setValue("company_name", data.folder_data.company_name)
            setValue("company_website", data.folder_data.company_website)
            setValue("about_the_company", data.folder_data.about_the_company)
            seteditid(data.id)
        }, 200);
        

    }

    const checkFolderUsageAndDelete = async (folder) => {
        try {
            // Check if folder has any agents assigned to it
            const response = await getFolderList(); // Get all folders with agent count if API supports it
            // Note: You might need to call a specific API to check folder usage
            // For now, checking if folder name suggests it has agents

            // If API doesn't provide agent count, you can check by calling the agents API
            // const agentsResponse = await getAIAgentsbyFolder(`folder_id=${folder.id}`);

            // For demo purposes, assuming API returns folder with agent_count or similar field
            const folderData = response.data?.folders?.find(f => f.id === folder.id);

            if (folderData && (folderData.agent_count > 0 || folderData.has_agents)) {
                triggerAlert('warning', 'Cannot Delete Folder', 'This folder cannot be deleted as it has agents assigned to it. Please remove all agents from this folder before deleting.');
                return;
            }

            // If no agents, proceed with deletion confirmation
            ConfirmationAlert(
                "Do you want to delete this folder from database?",
                "Delete",
                () => DeleteFolder(folder)
            );

        } catch (error) {
            // If API call fails, show warning and don't allow deletion
            triggerAlert('warning', 'Cannot Verify Folder Usage', 'Unable to verify if folder is in use. Please try again later.');
            console.error('Error checking folder usage:', error);
        }
    };

    const DeleteFolder = async (data) => {
        try {
            const response = await DeleteFolderName(data.id);
            const respdata = response.data;
            if (respdata.status_code == 200) {
                triggerAlert('success', '', `Folder deleted successfully` || 'Something went wrong');
                getFolderLists(page_size, page_number, searchTerm);
            }
        } catch (error) {
            triggerAlert('error', '', error.response.data.message || 'Something went wrong');
            console.error(error);
        }
    }
    useEffect(() => {
        getFolderLists();

        // Cleanup timeout on unmount
        return () => {
            if (searchTimeout) {
                clearTimeout(searchTimeout);
            }
        };
    }, [])
    const handleGenerateInfo = async () => {
        const companyName = getValues("company_name");
        const companyWebsite = getValues("company_website");

        if (!companyName || !companyWebsite) {
            alert("Please fill in Company Name and Company Website before generating info.");
            return;
        }

        const token = getOnlyToken();
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        };

        try {
            setLoading(true);

            const response = await axios.post(`/api/agents/company-info-gen/`,
                {
                    company_name: companyName,
                    company_website: companyWebsite,
                },
                config
            );
            const companyInfo = response.data?.Company_info?.[0]?.company_info;

            if (companyInfo) {
                setValue("about_the_company", companyInfo);
            } else {
                alert("No company info found in the response.");
            }
        } catch (error) {
            console.error("Error generating company info:", error);
            alert("Failed to generate company info. Please try again.");
        } finally {
            setLoading(false);
        }
    };
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box">
                        <h4 className="page-title lh-1 mb-3">Company</h4>
                    </div>
                </div>
            </div>


            <div className="row">
                <div className="page-title-box mb-3 d-flex justify-content-between align-items-center">
                    <div className="page-title-left">
                        {/* <button className="btn btn-success" onClick={() => navigate('/ai_agent')}>
                            <i className="ri-arrow-left-line me-1"></i>
                            Back
                        </button> */}
                    </div>
                    <div className="d-flex align-items-center gap-3">
                        <div className="app-search">
                            <form>
                                <div className="mb-0 position-relative">
                                    <input
                                        type="text"
                                        className="form-control border border-dark border-opacity-10"
                                        placeholder="Search folders..."
                                        value={searchTerm}
                                        onChange={handleSearchChange}
                                    />
                                    <span className="ri-search-line search-icon"></span>
                                </div>
                            </form>
                        </div>
                        <button className="btn btn-success" onClick={() => { sethide(true); reset(); seteditid("") }}>
                            <i className="ri-add-line me-1"></i>
                            Create Company
                        </button>
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="card  ">
                        <div className="card-body">
                            {loading ? <div className="text-center">   <div className="spinner-border text-success m-2" role="status"></div></div> :

                                <DataTable
                                    columns={columns}
                                    fixedHeader

                                    persistTableHead
                                    data={folderList}
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalPages}
                                    paginationDefaultPage={page_number}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    onChangePage={handlePageChange}
                                    paginationPerPage={page_size}

                                    theme="solarized"
                                    paginationComponentOptions={paginationComponentOptions}
                                    customStyles={customStyles}
                                />}
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={hide} onHide={() => sethide(false)} aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header closeButton>
                    <Modal.Title>{editid ? "Update Company" : "Create Company"}</Modal.Title>
                </Modal.Header>
                <form onSubmit={handleSubmit(submitFolder)}>
                    <Modal.Body>
                        {/* <div className="mb-3">
                            <label htmlFor="folderName" className="form-label">Folder Name</label>
                            <input
                                type="text"
                                id="folderName"
                                name="folderName"
                                {...register("folder_name", {
                                    required: "Folder name is required",
                                    minLength: {
                                        value: 3,
                                        message: "Minimum 3 characters Required."
                                    },

                                    pattern: {
                                        value: /^[A-Za-z]+$/,
                                        message: "Folder name must contain only alphabets"
                                    },
                                })}
                                className="form-control"
                                placeholder="Enter your Folder Name (alphabets only, 3-30 chars)"
                                autoComplete='off'
                            />
                            {errors.folder_name && <small className="text-danger d-block mb-2">{errors.folder_name.message}</small>}
                        </div> */}
                        <div className="mb-3 col-md-6">
                            <label htmlFor="CompanyName" className="form-label">
                                Company Name :
                                <span>
                                    <i className="ri-information-line fs-16"></i>
                                </span>
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="CompanyName"
                                placeholder="Enter your Company Name"
                                {...register("company_name", {
                                    required: "Company Name is required",
                                    pattern: {
                                        value: /^[A-Za-z0-9][A-Za-z0-9&-\s]+$/,
                                        message:
                                            "This field allows only alphabets and spaces, but does not accept a space as the first character.",
                                    },

                                })}
                            />
                            {errors.company_name && (
                                <p className="text-danger">{errors.company_name.message}</p>
                            )}
                        </div>

                        {/* Company Website */}
                        <div className="mb-3 col-md-6">
                            <label htmlFor="CompanyWebsite" className="form-label">
                                Company Website :
                                <span>
                                    <i className="ri-information-line fs-16"></i>
                                </span>
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="CompanyWebsite"
                                placeholder="https://www.pranathiss.com"
                                {...register("company_website", {
                                    required: " Company Website is required",

                                    pattern: {
                                        value: /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/,
                                        message: "Enter a valid website URL",
                                    }

                                })}
                            />
                            {errors.company_website && (
                                <p className="text-danger">
                                    {errors.company_website.message}
                                </p>
                            )}
                        </div>

                        {/* Company Info + Generate Button */}
                        <div className="mb-1 col-md-12">
                            <div>
                                <div className="d-flex justify-content-start align-items-center mb-2">
                                    <label
                                        htmlFor="CompanyInformation"
                                        className="form-label mb-0"
                                    >
                                        Company Information :
                                    </label>
                                    <button
                                        type="button"
                                        className="btn btn-success rounded-pill ms-2 px-3 py-1"
                                        onClick={handleGenerateInfo}
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <>
                                                <span
                                                    className="spinner-border spinner-border-sm me-1"
                                                    role="status"
                                                    aria-hidden="true"
                                                ></span>
                                                Generating...
                                            </>
                                        ) : (
                                            <>
                                                Generate <i className="ri-sparkling-2-line fs-18 ms-1"></i>
                                            </>
                                        )}
                                    </button>
                                </div>

                                <textarea
                                    className={`form-control ${errors.about_the_company ? "is-invalid" : ""}`}
                                    id="CompanyInformation"
                                    rows="8"
                                    placeholder="Provide detailed information about your company, products, and services"
                                    {...register("about_the_company", {
                                        required: "Company Information is required",

                                    })}
                                ></textarea>
                                {errors.about_the_company && (
                                    <div className="invalid-feedback">
                                        {errors.about_the_company.message}
                                    </div>
                                )}
                            </div>
                        </div>


                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-warning  rounded px-3" onClick={() => sethide(false)}>Cancel</button>
                        <button type="submit" className="btn btn-success  rounded px-3" disabled={disabled} >
                            {disabled ? <span className="spinner-border spinner-border-sm" role="status"  ></span> : ""}
                            Save
                        </button>
                    </Modal.Footer>
                </form>
            </Modal>
        </>

    )
}

export default Folders;